export type CapabilitiesType = 'car' | 'marine' | 'aviation' | 'radio';

/**
 * information that can be determined by capabilities
 */
export type InfoByCapabilities = {
    /**
     * The type of device based upon capabilities
     */
    type: CapabilitiesType;
};

/**
 * Get a information based upon capabilities
 * @param capabilities list of device capatibilities
 * @returns information that can be determined by capabilities
 */
export function getInfoByCapabilities(
    capabilities: string[],
): InfoByCapabilities {
    return {
        type: getType(capabilities),
    };
}

function getType(capabilities: string[]): CapabilitiesType {
    if (isMarine(capabilities)) {
        return 'marine';
    } else if (isAviation(capabilities)) {
        return 'aviation';
    }
    /**
     * TODO:
     * How to determine radio v car
     */
    return 'car';
}

function isMarine(capabilities: string[]): boolean {
    return hasIntersect(marineCodes, capabilities);
}

function isAviation(capabilities: string[]): boolean {
    return hasIntersect(aviationCodes, capabilities);
}

function hasIntersect(list: string[], capabilities: string[]): boolean {
    return list.some((code) => capabilities?.includes(code));
}

const marineCodes = [
    'IND',
    'OFF',
    'CST',
    'SKY',
    'MAR',
    'INL',
    'FSH',
    'CHA',
    'VOY',
    'FISHMAP',
];

const aviationCodes = ['PIL', 'AVI', 'FORFLT', 'RSP'];
